export default "__VITE_ASSET__Cs_miR8O__"